import { IS_NEW_BACKEND_API } from '@skytech/utils'

import { get } from '@/util/auth'

import { API_ROUTE_DEPARTMENT_HEAD } from './api-routes'

type DepartmentHeadOriginal = {
  id: number
  email?: string
  phoneNumber?: string
  firstName: string
  lastName: string
  type: string
}

export const departmentResources = {
  getDepartmentHead: async (departmentId: number) => {
    if (departmentId < 1) return null
    const route = API_ROUTE_DEPARTMENT_HEAD.replace(':departmentId', String(departmentId))
    return await get<DepartmentHeadOriginal>(route, IS_NEW_BACKEND_API)
  },
}

export type DepartmentHead = Awaited<ReturnType<typeof departmentResources.getDepartmentHead>>
